<div class="col-sm-2 dashboard-card-content ps-3 pe-3">

  <div class="card bg-transparent border-0 m-0">
    <div class="card-body p-0">
      <h6 class="dashboard-card-hdr mt-2">
        <div class="row">
          <div class="col-sm-10 d-flex">
            <a style="padding-left:18px;" routerLink="/bu/{{batchSummary.businessUnitId}}/batch/{{batchSummary.id}}" title="{{batchSummary.name}}" [innerHtml] = "batchSummary.name">         
            </a>
          </div>

          <div class="col-sm-2">
            <div class="row">
              <div class="col-sm-1">

              </div>
              <div class="col-sm-1 timesheetdeleteicon"
                     (click)="onDeleteTimesheet(batchSummary)"
                   [ngClass]="batchSummary.totalTimecards == 0 && batchSummary.departmentId == buAccess.departmentId?'talent-delete':'' "
                   [attr.disabled]="!(batchSummary.totalTimecards == 0 && batchSummary.departmentId == buAccess.departmentId)||null">
                <span class="fa fa-trash"
                      [attr.disabled]="!(batchSummary.totalTimecards == 0 && batchSummary.departmentId == buAccess.departmentId)||null"
                      [ngClass]="batchSummary.totalTimecards == 0 && batchSummary.departmentId == buAccess.departmentId?'active-delete':'inactive-delete'"                    
                      title="Delete"></span>
              </div>
            </div>
          </div>
        </div>
      </h6>
      <div class="dashboard-card-body">
        <div class="row">
          <div class="col-sm-6">
            <p class="card-text">Created On:  <p>
          </div>

          <div class="col-sm-6">
            <!--<p>{{moment(batchSummary.createdDate).format('DD MMM  YYYY')}}</p>-->
            {{batchSummary.createdDate}}
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="card-text">Last Updated By:  <p>
          </div>

          <div class="col-sm-6">
            <p>{{batchSummary.audit.updatedByName}}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="card-text">Last Updated On:  <p>
          </div>

          <div class="col-sm-6">
            <!--<p>{{moment(batchSummary.audit.updateDate).format('DD MMM  YYYY')}}</p>-->
            <p>{{batchSummary.audit.updateDate}}</p>
          </div>
        </div>
      </div>

      <div class="row dashboard-card-footer">
        <div class="col-sm-4 dashboard-card-footer-timecard">
          <p>{{batchSummary.totalTimecards}}<br /><span>Timecards</span></p>
        </div>
        <!--SCOR-26468-->
        <div class="col-sm-8">
            <ng-container *ngFor="let tc of batchSummary.timecardStatusCount">
              <a *ngIf="tc.timecardCount > 0" href="/scorepay/bu/{{batchSummary.businessUnitId}}/batch/{{batchSummary.id}}/wrfid/{{tc.id}}">
                <span class="label dashboard-card-footer count-label {{tc.description}}"
                  title="{{tc.timecardCount}} {{tc.description}}">
                    {{tc.timecardCount}}
                </span>
              </a>
            </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
